<template>
  <div class="banner">
    <img v-if="bannerUrl&&bannerUrl[0]" :src="baseUrl+bannerUrl[0].path" alt="">
    <div class="abs">
      <div class="wz" :style="wz.wz1=='第一时间'?'opacity: 0':'opacity: 1'">
        <div class="wz1"><span>{{wz.wz1}}</span>{{wz.wz2}}</div>
        <div class="wz2">{{wz.wz3}}</div>
      </div>
      <div style="cursor: pointer;" class="btn" @click="goDownload">中富投顾终端下载</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'banner',
  props: {
        type: {
            type: Number,
            default: 0
        },
        bannerUrl:{
            type: Array
        }
    },
  data() {
      return {
        baseUrl:this.$store.state.baseUrl,
        list:[{wz1:"用心专注",wz2:"成就财富",wz3:"010-58701668（北京）、028-68517888（四川）"},
        {wz1:"第一时间",wz2:"最新动态",wz3:"关注微信 关注公众号 关注抖音 关注视频号"},
        {wz1:"选择中富金石，与高质量同行",wz2:"",wz3:"010-58701668（北京）、028-68517888（四川）"},
        {wz1:"保护投资者合法权益",wz2:"",wz3:"010-58701668（北京）、028-68517888（四川）"}],
        wz:{}
      }
  },
  created() {
  },
  mounted() {
    this.wz=this.list[this.type]
      

  },
  methods: {
    goDownload(){
      this.$router.push("/download")
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @media (min-width:500px) {
  .banner{
    position: relative;
    width: 100%;
    img{
      width: 100%;
      object-fit:contain;
    }
    .abs{
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      position: absolute;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .wz{
        margin-right: 2.57rem;
        .wz1{
          white-space: nowrap;
          font-size: 0.54rem;
          font-family: Work Sans-Bold, Work Sans;
          font-weight: bold;
          margin-bottom: 0.45rem;
          span{
            margin-right: 0.6rem;
          }
        }
        .wz2{
          user-select: none;
          white-space: nowrap;
          font-size: 0.36rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
      .btn{
        white-space: nowrap;
        padding: 0.22rem 0.3rem;
        border-radius: 0.03rem;
        border: 0.03rem solid #FFFFFF;
        font-size: 0.27rem;
        font-family: Work Sans-SemiBold, Work Sans;
        font-weight: 600;
      }
    }
  }
}
@media (max-width:500px) {
  .banner{
    position: relative;
    width: 100%;
    height: 4rem;
    img{
      width: 100%;
      object-fit: cover;
      height: 4rem;
    }
    .abs{
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      position: absolute;
      color: #fff;
      .wz{
        .wz1{
          white-space: nowrap;
          font-size: 0.48rem;
          font-family: Work Sans-Bold, Work Sans;
          font-weight: bold;
          margin-bottom: 0.24rem;
          span{
            margin-right: 0.5rem;
          }
        }
        .wz2{
          user-select: none;
          white-space: nowrap;
          font-size: 0.3rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
      .btn{
        margin-top: 0.48rem;
        width: 3.52rem;
        height: 1.04rem;
        border-radius: 0.04rem;
        border: 0.04rem solid #FFFFFF;
        font-size: 0.34rem;
        font-family: Work Sans-SemiBold, Work Sans;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue